import { render, staticRenderFns } from "./App.vue?vue&type=template&id=e0dffc08&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=e0dffc08&prod&lang=scss&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=e0dffc08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dffc08",
  null
  
)

export default component.exports